import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Grid,
  Group,
  Input,
  Menu,
  MultiSelect,
  MultiSelectProps,
  rem,
  Select,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  IconActivity,
  IconBarcode,
  IconBuildingWarehouse,
  IconCaretDown,
  IconCode,
  IconEdit,
  IconEye,
  IconFileExport,
  IconHandStop,
  IconMapPin,
  IconPlus,
  IconSearch,
  IconSignature,
  IconSwitch,
  IconTrash,
  IconX,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { useForm } from "@mantine/form";
import {
  repositoryMdm,
  styleTableMantine,
} from "../../../../_base/_const/_constVar";
import { BASE_API_MDM } from "../../../../config";
import { green } from "../../../../const/variables";
import _breadcrumb from "../../../../_base/component/_layout/_breadcrumb";
import DetailProvince from "./DetailProvince";
import { modals } from "@mantine/modals";
import { _localization } from "../../../../config/location";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import DeleteProvince from "./DeleteProvince";
import { MessageResponse } from "../../../../model/MessageResponse";
import ProvinceForm from "./ProvinceForm";
import { SelectListItemModel } from "../../../../model/SelectListItem";
interface SearchCriteria {
  KeySearch?: string;
  Active?: boolean;
  Code?: string;
  Name?: string;
}
function getColorStatus(text: boolean) {
  return text === true || text === null ? "teal" : "red";
}
const Province = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [dataProvinceCode, setDataProvinceCode] = useState<
    SelectListItemModel[]
  >([]);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<InventoryItem[]>([]);
  const [rowCount, setRowCount] = useState(0);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [selectedIds, setSelectedIds] = useState<any[]>([]);
  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {},
  });

  type InventoryItem = {
    id: number;
    nameprovince: string;
    note: string | null;
    codeprovince: string;
    active: boolean;
    codeprovinceweb: string;
    createdate: string | null;
    lastupdatedate: string | null;
    createby: string | null;
    lastupdateby: string | null;
  };
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 50,
      },
      {
        accessorKey: "id",
        header: "ID",
      },
      {
        accessorKey: "code",
        header: "Mã Tỉnh/Thành phố",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="dot"
              size="lg"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() => {
                detailItem(row.original.id);
              }}
            >
              {renderedCellValue === null ? null : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "name",
        header: "Tên Tỉnh/Thành phố",
      },
      // {
      //   accessorKey: "codeprovinceweb",
      //   header: "Mã Tỉnh/Thành phố web",
      // },
      {
        accessorKey: "note",
        header: "Ghi chú",
      },
      {
        accessorKey: "active",
        header: "Sử dụng",
        filterFn: "equals",
        mantineFilterSelectProps: {
          data: [
            { label: "Đang sử dụng", value: "true" },
            { label: "Dừng sử dụng", value: "false" },
          ],
        },
        filterVariant: "select",
        Cell: ({ renderedCellValue, row }) => (
          <Badge color={getColorStatus(row.original.active)}>
            {row.original.active === true || row.original.active === null
              ? "Đang sử dụng"
              : "Dừng sử dụng"}
          </Badge>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 175,
        Cell: ({ row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="orange"
                onClick={async () => {
                  editItem(row.original.id);
                }}
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>

            <Tooltip label="Chi tiết">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="cyan"
                onClick={async () => {
                  detailItem(row.original.id);
                }}
              >
                <IconEye size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>

            <Tooltip
              label={row.original.active === true ? "Dừng sử dụng" : "Sử dụng"}
            >
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color={row.original.active === true ? "violet" : "green"}
                onClick={async () => {
                  await activesData(!row.original.active, row.original.id);
                }}
              >
                {row.original.active === true ? (
                  <IconHandStop size={20} />
                ) : (
                  <IconActivity size={20} />
                )}
              </ActionIcon>
            </Tooltip>

            <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="red"
                onClick={async () => {
                  await deleteData([row.original.id]);
                }}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    [data]
  );

  const exportDataExcel = async () => {
    let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;
    const search = form.getValues();

    const params = new URLSearchParams();
    Object.entries(search).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        value.forEach((item) => params.append(key, String(item)));
      } else if (typeof value === "string" && value.length > 0) {
        params.append(key, value);
      }
    });
    // if (search.province && search.province.length > 0) {
    //   search.province.forEach((province) => {
    //     url += `&ProvinceCodes=${province}`;
    //   });
    // }
    const baseUrl = `/api/v1/ExportExcel/export-province${url}`;
    const _url = BASE_API_MDM + baseUrl;
    const token = localStorage.getItem("token");

    const response = await fetch(_url, {
      method: "GET",
      headers: {
        "Content-Type": "application/vnd.ms-excel",
        Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to download file");
    }
    const blob = await response.blob();
    const urlss = window.URL.createObjectURL(blob);
    const _name = new Date().toISOString().slice(0, 10);
    let filename = "Danh_muc_tinh.xlsx";
    const link = document.createElement("a");
    link.href = urlss;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };
  // Hàm lấy dữ liệu
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    const search = form.getValues();

    const params = new URLSearchParams();
    Object.entries(search).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        value.forEach((item) => params.append(key, String(item)));
      } else if (typeof value === "string" && value.length > 0) {
        params.append(key, value);
      }
    });

    url += `&${params.toString()}`;
    try {
      const response = await repositoryMdm.get(
        `/api/v1/TblDmProvinceMoi/get-list${url}`
      );
      if (response && response.success) {
        const result = response.data;
        setData(result);
        setRowCount(response.totalCount);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };
  // const DataProvinceCode = async () => {
  //   try {
  //     const response = await repositoryMdm.get<MessageResponse<[]>>(
  //       `/api/v1/TblDmProvince/get-all`
  //     );
  //     if (response && response.success) {
  //       const result = response.data
  //         .filter((i: any) => i.id !== null && i.codeprovince !== null)
  //         .map((item: any) => ({
  //           value: item.codeprovince,
  //           label: item.codeprovince + " - " + item.nameprovince,
  //         }));
  //       setDataProvinceCode(result);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     return;
  //   }
  // };
  const deleteData = async (ids: number[]) => {
    if (ids.length < 1) NotificationExtension.Warn("Bạn chưa chọn dữ liệu !");
    else
      try {
        modals.openConfirmModal({
          title: (
            <>
              <Title order={5}>Xóa danh mục Tỉnh/Thành phố!</Title>
            </>
          ),
          size: "550px",
          children: (
            <DeleteProvince idItems={ids} onClose={setDeleteViewStatus} />
          ),
          confirmProps: { display: "none" },
          cancelProps: { display: "none" },
        });
      } catch (error) {
        console.error(error);
        return;
      }
  };
  function detailItem(id: number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chi tiết Tỉnh/Thành phố!</Title>
        </>
      ),
      size: "auto",
      children: <DetailProvince id={id} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }
  function editItem(id: string | number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa danh mục Tỉnh/Thành phố!</Title>
        </>
      ),
      size: "auto",
      children: (
        <ProvinceForm id={id} onClose={setDeleteViewStatus} isEditMode={true} />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }
  function createItem() {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Thêm mới danh mục Tỉnh/Thành phố!</Title>
        </>
      ),
      size: "auto",
      children: (
        <ProvinceForm onClose={setDeleteViewStatus} isEditMode={false} />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }
  const activesData = async (status: boolean, id: string | number) => {
    if (Number(id) < 1)
      NotificationExtension.Success("Bạn chưa chọn dữ liệu !");
    else
      try {
        const res = await repositoryMdm.post<MessageResponse<boolean>>(
          `/api/v1/TblDmProvinceMoi/active`,
          { id: id, active: status }
        );
        if (res && res.success) {
          NotificationExtension.Success("Cập nhật thành công !");
          setDeleteViewStatus((prev: any) => !prev);
        } else NotificationExtension.Fails("Cập nhật thất bại !");
      } catch (error) {
        console.error(error);
        return;
      }
  };
  const activeData = async (status: boolean) => {
    if (selectedIds.length < 1)
      NotificationExtension.Success("Bạn chưa chọn dữ liệu !");
    else
      try {
        const res = await repositoryMdm.post<MessageResponse<boolean>>(
          `/api/v1/TblDmProvince/actives`,
          {
            ids: [Number(selectedIds)],
            status: status,
          }
        );
        if (res && res.success) {
          NotificationExtension.Success("Cập nhật thành công !");
          await fetchData();
        } else NotificationExtension.Fails("Cập nhật thất bại !");
      } catch (error) {
        console.error(error);
        return;
      }
  };
  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectedIds(valuesList);
    if (valuesList.length < 1) setSelectedIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectedIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    if (pagination.pageIndex === 0 && data.length < pagination.pageSize) {
      fetchData();
    } else {
      fetchData();
    }
  }, [pagination.pageIndex, pagination.pageSize, deleteViewStatus]);
  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    enableTopToolbar: false,
    enablePagination: true,
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    // enableRowSelection: true,
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    getRowId: (row) => row.id,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (270 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);
  const renderMultiSelectOption: MultiSelectProps["renderOption"] = ({
    option,
  }) => (
    <Group gap="sm">
      <Text>
        {dataProvinceCode.find((x) => x.value === option.value)?.label}
      </Text>
    </Group>
  );
  return (
    <Box>
      <div
        style={{
          border: "1px solid #dee2e6",
          padding: "10px",
          display: "flex",
          gap: "10px",
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
        ref={headerRef}
      >
        <Grid>
          <Grid.Col style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <Input
              placeholder="Nhập tìm kiếm"
              key={form.key("KeySearch")}
              type="text"
              leftSection={<IconSearch size={"20"} color="#15aabf" />}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
              {...form.getInputProps("KeySearch")}
            />
            <TextInput
              placeholder="Nhập mã tỉnh/thành phố"
              key={form.key("Code")}
              leftSection={<IconCode size={"20"} color="#15aabf" />}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
              {...form.getInputProps("Code")}
            />
            <TextInput
              placeholder="Nhập tên tỉnh/thành phố"
              key={form.key("Name")}
              leftSection={<IconSignature size={"20"} color="#15aabf" />}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
              {...form.getInputProps("Name")}
            />
            <Select
              placeholder="Trạng thái"
              key={form.key("Active")}
              leftSection={<IconActivity size={20} color="#15aabf" />}
              data={[
                { label: "Đang hoạt động", value: "true" },
                { label: "Dừng hoạt động", value: "false" },
              ]}
              {...form.getInputProps("Active")}
            />
            <Button
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
        <Group gap={0} justify="space-between">
          <Button
            mr={10}
            leftSection={<IconPlus size={14} />}
            color="blue"
            variant="outline"
            onClick={async () => {
              createItem();
            }}
          >
            Thêm mới
          </Button>
          {/* <Menu shadow="md" width={200}>
            <Menu.Target>
              <Button
                rightSection={
                  <IconCaretDown style={{ width: rem(14), height: rem(14) }} />
                }
              >
                Chức năng
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Label>Application</Menu.Label>
              <Menu.Item
                leftSection={
                  <IconFileExport style={{ width: rem(14), height: rem(14) }} />
                }
                onClick={() => exportDataExcel()}
              >
                Export Excel
              </Menu.Item>
              <Menu.Item
                leftSection={
                  <IconActivity style={{ width: rem(14), height: rem(14) }} />
                }
                disabled={selectedIds.length < 1}
                onClick={() => activeData(true)}
              >
                Sử dụng
              </Menu.Item>

              <Menu.Item
                leftSection={
                  <IconHandStop style={{ width: rem(14), height: rem(14) }} />
                }
                disabled={selectedIds.length < 1}
                onClick={() => activeData(false)}
              >
                Dừng sử dụng
              </Menu.Item>
              <Menu.Item
                leftSection={
                  <IconTrash style={{ width: rem(14), height: rem(14) }} />
                }
                disabled={selectedIds.length < 1}
                onClick={() => deleteData(selectedIds)}
              >
                Xóa (chọn nhiều)
              </Menu.Item>
              <Menu.Item
                leftSection={
                  <IconX style={{ width: rem(14), height: rem(14) }} />
                }
              >
                Đóng
              </Menu.Item>
            </Menu.Dropdown>
          </Menu> */}
        </Group>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

export default Province;
